module.exports = __webpack_public_path__ + "img/MovieApp.6f34939e.png";